import { render, staticRenderFns } from "./hqglLogisticsFixDetail.vue?vue&type=template&id=01a134ec&scoped=true&"
import script from "./hqglLogisticsFixDetail.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsFixDetail.vue?vue&type=script&lang=js&"
import style0 from "./hqglLogisticsFixDetail.vue?vue&type=style&index=0&id=01a134ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a134ec",
  null
  
)

export default component.exports